import { render, staticRenderFns } from "./Emergency_open.vue?vue&type=template&id=91a1a2fe"
import script from "./Emergency_open.vue?vue&type=script&lang=js"
export * from "./Emergency_open.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports